import { ErrorTypes } from '../../field-error/error-types';
export const OTHER_ID = 'Other';
const getValueIncludesOther = (value, optionsNames) => value.some(_value => !optionsNames.includes(_value));
export const getIsOtherOptionSelected = (value, optionsNames) => value.length > 0 && getValueIncludesOther(value, optionsNames);
export const getOtherLabel = (addOtherLabel, t) => {
  const otherLabelDefault = t == null ? void 0 : t('add-other.default-other-option-label');
  return addOtherLabel || otherLabelDefault || OTHER_ID;
};
export const getOtherValue = (value, addOtherLabel) => {
  const addedSymbolsLength = 2; // we add ': ' to other value
  const otherLabelLength = addOtherLabel ? addOtherLabel.length + addedSymbolsLength : 0;
  const otherItem = value.find(item => item.startsWith(`${addOtherLabel}: `)) || '';
  return otherItem.slice(otherLabelLength);
};
export const getOptionsNames = options => options.map(option => option.label);
export const getOptionsValues = options => options.map(option => option.value ?? option.label);
export const getCheckboxGroupError = (validation, error) => {
  var _validation$array, _validation$array2;
  const isMinMaxItemsError = (error == null ? void 0 : error.errorType) === ErrorTypes.MIN_ITEMS_ERROR || (error == null ? void 0 : error.errorType) === ErrorTypes.MAX_ITEMS_ERROR;
  if (!error || !isMinMaxItemsError) {
    return error;
  }
  const minItems = validation == null || (_validation$array = validation.array) == null ? void 0 : _validation$array.minItems;
  const maxItems = validation == null || (_validation$array2 = validation.array) == null ? void 0 : _validation$array2.maxItems;
  const isMinMaxItems = minItems && maxItems;
  if (isMinMaxItems && minItems === maxItems) {
    return {
      ...error,
      errorType: ErrorTypes.EXACT_ITEMS_NUMBER_ERROR,
      errorMessage: `must choose ${minItems} options`
    };
  }
  return error;
};
//# sourceMappingURL=checkbox-group-field-utils.js.map